import { BrandMark } from "@/components/BrandMark";
import InstagramFeed from "@/components/InstagramFeed";

export function SiteFooter() {
  return (
    <footer className="border-t border-[#27272A] bg-[#050505] mt-24" data-testid="site-footer">
      {/* Curated Instagram strip — quietly disappears if Coach hasn't curated any "Footer" posts */}
      <div className="border-b border-[#27272A] bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-3">
          <InstagramFeed placement="footer" limit={8} variant="strip" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-4 gap-8 text-sm text-zinc-400">
        <div>
          <BrandMark size="lg" className="mb-4" />
          <p className="text-zinc-500 text-xs leading-relaxed">Private boxing coaching — live via Zoom from anywhere in the world, and in person in Somerset County &amp; Central New Jersey.</p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#FF331F] mt-3 font-bold">Better Through Boxing</p>
        </div>
        <div>
          <div className="font-display uppercase text-xs tracking-widest text-white mb-3">Train</div>
          <ul className="space-y-2">
            <li>BTB Basics Program · $699</li>
            <li>Single Session · $100</li>
            <li>Alumni Rate · $70</li>
          </ul>
        </div>
        <div>
          <div className="font-display uppercase text-xs tracking-widest text-white mb-3">Contact</div>
          <address className="not-italic space-y-2">
            <div className="text-white font-semibold" data-testid="footer-business-name">The Flow State Method LLC</div>
            <div data-testid="footer-service-area">Private in-home boxing training across Somerset County &amp; Central New Jersey. <a href="/boxing-lessons" className="text-[#FF331F] hover:text-white">See all service areas &rarr;</a></div>
            <div><a href="tel:+17326484949" className="hover:text-white" data-testid="footer-phone">(732) 648-4949</a> · <a href="sms:+17326484949" className="hover:text-white" data-testid="footer-sms">Text us</a></div>
            <div className="text-zinc-500 text-xs pt-1">In-person: Mon–Fri 9AM–8PM · Sat 3–9PM</div>
            <div className="text-zinc-500 text-xs">Online (Zoom): Daily 6AM–11PM</div>
            <div><a href="https://maps.google.com/maps?cid=12009279507527467511" target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-maps">View on Google Maps &rarr;</a></div>
          </address>
        </div>
        <div>
          <div className="font-display uppercase text-xs tracking-widest text-white mb-3">Legal</div>
          <ul className="space-y-2">
            <li><a href="/blog" className="hover:text-white" data-testid="footer-blog">Journal</a></li>
            <li><a href="/boxing-lessons" className="hover:text-white" data-testid="footer-locations">Boxing Lessons in NJ</a></li>
            <li><a href="/boxing-glossary" className="hover:text-white" data-testid="footer-glossary">Boxing Glossary</a></li>
            <li><a href="/faq" className="hover:text-white" data-testid="footer-faq">FAQ</a></li>
            <li><a href="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Service</a></li>
            <li><a href="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</a></li>
            <li><a href="/data-deletion" className="hover:text-white" data-testid="footer-data-deletion">Data Deletion</a></li>
            <li><a href="/waiver" className="hover:text-white" data-testid="footer-waiver">Liability Waiver</a></li>
          </ul>
        </div>
        <div>
          <div className="font-display uppercase text-xs tracking-widest text-white mb-3">Connect</div>
          <ul className="space-y-2">
            <li><a href="https://www.instagram.com/flow_state_method" target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-instagram">Instagram @flow_state_method</a></li>
            <li><a href="/social" className="hover:text-white" data-testid="footer-social">Social feed →</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#27272A] py-5 text-center text-xs text-zinc-600 uppercase tracking-widest">© {new Date().getFullYear()} The Flow State Method LLC · &ldquo;Better Through Boxing&rdquo; is a brand of The Flow State Method LLC</div>
    </footer>
  );
}
